import React, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box, Loader as SmoresLoader, Text } from '@mrshmllw/smores-react'

type LoaderProps = {
  showLine?: boolean
}

const Loader: FC<LoaderProps> = ({ showLine = false }) => {
  const [showLineState, setShowLineState] = useState(false)

  useEffect(() => {
    const interval = setTimeout(() => {
      setShowLineState(showLine)
    }, 100)

    return () => clearInterval(interval)
  }, [showLine])

  return (
    <Container>
      <Box mb="24px">
        <SmoresLoader height="52px" />
      </Box>

      {showLineState && (
        <Box maxWidth="185px" mx={{ custom: 'auto' }}>
          <Text tag="h2" typo="headline-regular" align="center">
            We&rsquo;re just grabbing your quote...
          </Text>
        </Box>
      )}
    </Container>
  )
}

const Container = styled(Box)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 4;
`

export default Loader
